import { lazy, Suspense } from 'react'

const ConnectedPresentationCreatorModalComponent = lazy(
  () => import('./ConnectedPresentationCreatorModal')
)

export const ConnectedPresentationCreatorModal: React.VFC = (props) => (
  <Suspense fallback={null}>
    <ConnectedPresentationCreatorModalComponent {...props} />
  </Suspense>
)
